module.exports = __webpack_public_path__ + "static/media/lottery_header.66c51bd7.png";